import { render, staticRenderFns } from "./setLitigationPlan.vue?vue&type=template&id=427343ae&scoped=true&"
import script from "./setLitigationPlan.vue?vue&type=script&lang=tsx&"
export * from "./setLitigationPlan.vue?vue&type=script&lang=tsx&"
import style0 from "./setLitigationPlan.vue?vue&type=style&index=0&id=427343ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427343ae",
  null
  
)

export default component.exports